import { useContext } from 'react'
import { useTheme } from '@mui/material'
import CloudOffOutlined from '@mui/icons-material/CloudOffOutlined'
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined'
import { ThemeContext } from '../../App'
import SvgCustomIcon from '../icons/SvgCustomIcon'

/** Stesso colore delle icone SvgCustomIcon nel menu laterale. */
export function useOfflineNavIconColor() {
  const { mode } = useContext(ThemeContext)
  const theme = useTheme()
  return mode === 'dark' ? '#EDEDED' : theme.palette.newColors.gray
}

const MUI_ICON_SX = (size, color) => ({
  fontSize: size,
  color,
  display: 'block',
})

/**
 * Icone sezione Offline data: colore allineato al menu e simboli coerenti con import/export.
 *
 * @param {'offline' | 'prepare' | 'export' | 'import' | 'history'} variant
 * @param {number} [size=20]
 */
export function OfflineNavIcon({ variant, size = 20 }) {
  const color = useOfflineNavIconColor()

  switch (variant) {
    case 'offline':
      return <CloudOffOutlined sx={MUI_ICON_SX(size, color)} />
    case 'prepare':
      return <SvgCustomIcon name="download" size={size} color={color} />
    case 'export':
      return <FileDownloadOutlined sx={MUI_ICON_SX(size, color)} />
    case 'import':
      return <FileUploadOutlined sx={MUI_ICON_SX(size, color)} />
    case 'history':
      return <SvgCustomIcon name="history" size={size} color={color} />
    default:
      return null
  }
}
